import { ValidatorService } from '../tools/validator.service';
import { ConstantsService } from '../constants.service';
import { AutenticacionService } from '../autenticacion.service';
import { ErrorsService } from '../tools/errors.service';
import { Http, URLSearchParams } from '@angular/http';
import { Injectable } from '@angular/core';


@Injectable()
export class ReporteCuentasPorPagarService {
  
  private service_url: string;

  constructor(private http: Http, private constantsService: ConstantsService, private validatorService: ValidatorService,
    private authService: AutenticacionService, private errorService:ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/reportes/reporte-cuentas-por-pagar';
  }

  public getCuentasPorPagar(filters: any) {
    let myParams = new URLSearchParams();
    
    if(filters.fecha_pago_limite){
      myParams.append('fecha_pago_limite', filters.fecha_pago_limite);
    }

    if(filters.id_obra){
        myParams.append('id_obra', filters.id_obra);
    }

    if(filters.id_proveedor){
      myParams.append('id_proveedor', filters.id_proveedor);
    }

    if(filters.id_concepto){
      myParams.append('id_concepto', filters.id_concepto);
    }

    if(filters.estatus){
      myParams.append('estatus', filters.estatus);
    }

    if(filters.fechaInicio){
      console.log("filters.fechaInicio: ",filters.fechaInicio);
      myParams.append('fechaInicio', filters.fechaInicio);
    }

    if(filters.fechaFin){
      myParams.append('fechaFin', filters.fechaFin);
      console.log("filters.fechaFin: ",filters.fechaFin);
    }

    if(filters.importe_min){
      myParams.append('importe_min', filters.importe_min);
    }

    if(filters.importe_max){
      myParams.append('importe_max', filters.importe_max);
    }

    if(filters.id_creador_gasto){
      myParams.append('id_creador_gasto', filters.id_creador_gasto);
    }

    const options = this.authService.getAuthHeaders();
    options.params = myParams;

    return this.http.get(this.service_url, options);
  }

  public getCuentasPorPagarEstatus(){
    return this.http.get(this.constantsService.apiURL + '/publicos/cuentas-por-pagar/estatus', this.authService.getAuthHeaders());
  }
}


// WEBPACK FOOTER //
// ./src/app/services/reportes/reporte-cuentas-por-pagar.service.ts